import { render } from "./ProjectDetailsView.vue?vue&type=template&id=5cac8702&scoped=true&ts=true"
import script from "./ProjectDetailsView.vue?vue&type=script&lang=ts"
export * from "./ProjectDetailsView.vue?vue&type=script&lang=ts"

import "./ProjectDetailsView.vue?vue&type=style&index=0&id=5cac8702&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cac8702"]])

export default __exports__